import { LightMode, Flex, FormErrorMessage, Text, Box } from '@telescope/cassini-ui';
import { RiErrorWarningFill } from 'react-icons/ri';
import { useTheme } from '@telescope/cassini-hooks';

export const ErrorWarning = ({ children } : { children: React.ReactNode }) => {
  const theme = useTheme();
  const { errorColorScheme: c } = theme.settings;

  return (
    <FormErrorMessage>
      <LightMode>
        <Flex bg={`${c}.100`} w="100%" borderRadius={3} mb={5} p={3} alignItems="center" gap={2}>
          <Box flexShrink={0}>
            <RiErrorWarningFill color={`${c}.500`} size={18} />
          </Box>
          
          <Text color="#000" sx={{ button: { color: `${c}.500` }}} colorScheme={c} textAlign="left" fontSize="xs">
            { children }
          </Text>
        </Flex>
      </LightMode>
    </FormErrorMessage>
  )
}